import CustomFormExtendable from "../../../bootstrap/components/custom-form/CustomFormExtendable";
import checkError_image from './error-checking/image';
import checkError_images from './error-checking/images';
import checkError_video from './error-checking/video';
import checkError_videos from './error-checking/videos';
import checkError_audio from './error-checking/audio';
import checkError_audios from './error-checking/audios';
import checkError_document from './error-checking/document';
import checkError_documents from './error-checking/documents';
import checkError_richText from './error-checking/richText';
import inputComponent_image from './input-component/image';
import inputComponent_images from './input-component/images';
import inputComponent_video from './input-component/video';
import inputComponent_videos from './input-component/videos';
import inputComponent_audio from './input-component/audio';
import inputComponent_audios from './input-component/audios';
import inputComponent_document from './input-component/document';
import inputComponent_documents from './input-component/documents';
import inputComponent_richText from './input-component/richText';

export default function extendCustomForm() {

    CustomFormExtendable.getInputComponent = function (type, props) {
        switch (type) {
            case 'image':
                return inputComponent_image(props);
            case 'images':
                return inputComponent_images(props);
            case 'video':
                return inputComponent_video(props);
            case 'videos':
                return inputComponent_videos(props);
            case 'audio':
                return inputComponent_audio(props);
            case 'audios':
                return inputComponent_audios(props);
            case 'document':
                return inputComponent_document(props);
            case 'documents':
                return inputComponent_documents(props);
            case 'richText':
                return inputComponent_richText(props);
        }

        return null;
    };

    CustomFormExtendable.normalizeValue = function (value, type) {
        switch (type) {
            case 'image':
                return value === undefined || value === null ? null : value;
            case 'images':
                return value || [];
            case 'video':
                return value === undefined || value === null ? null : value;
            case 'videos':
                return value || [];
            case 'audio':
                return value === undefined || value === null ? null : value;
            case 'audios':
                return value || [];
            case 'document':
                return value === undefined || value === null ? null : value;
            case 'documents':
                return value || [];
            case 'richText':
                return value || null;
        }

        return value;
    }

    CustomFormExtendable.checkError = function (type, value, rules, options, allValues) {
        switch (type) {
            case 'image':
                return checkError_image(value, rules, options, allValues);
            case 'images':
                return checkError_images(value, rules, options, allValues);
            case 'video':
                return checkError_video(value, rules, options, allValues);
            case 'videos':
                return checkError_videos(value, rules, options, allValues);
            case 'audio':
                return checkError_audio(value, rules, options, allValues);
            case 'audios':
                return checkError_audios(value, rules, options, allValues);
            case 'document':
                return checkError_document(value, rules, options, allValues);
            case 'documents':
                return checkError_documents(value, rules, options, allValues);
            case 'richText':
                return checkError_richText(value, rules, options, allValues);
        }

        return null;
    };


    CustomFormExtendable.parseRequiredRuleValue = function (ruleValue) {
        return ruleValue === true;
    };

}
